// src/components/pages/EventManager/atoms/ErrorMessage.js

import React from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";

const ErrorMessage = ({ message }) => {
  if (!message) return null;

  console.log("ErrorMessage received:", message); // Debugging log
  return (
    <Typography
      color="error"
      sx={{
        mt: 2,
        fontFamily: "basic-sans",
        fontWeight: "bold",
      }}
    >
      {message}
    </Typography>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export default ErrorMessage;
